import { GetHelpMenuDisplayItemsQuery } from 'generated/graphql';

// This state is persisted to browser localStorage. Do not add any sensitive information that would
// pose a security risk.
// Refer to createLocalStorageEnhancer

interface HelpMenuState {
  //Mapping which notifyItem has been "read"/ viewed. Viewing a notifyItem
  //will not update across clients. True = has been read or viewed
  notifyItemReadStatusMap: { [notifyItemId: number]: boolean };
}

const initialState: HelpMenuState = {
  notifyItemReadStatusMap: {},
};

export default function reducer(state = initialState, action: BaseTockAction): HelpMenuState {
  const { type, payload } = action;
  switch (type) {
    case 'SET_NOTIFY_ITEM_READ_STATUS': {
      const { notifyItemId, isRead } = payload;

      if (!Object.hasOwn(state.notifyItemReadStatusMap, notifyItemId)) {
        return state;
      }

      return {
        ...state,
        notifyItemReadStatusMap: {
          ...state.notifyItemReadStatusMap,
          [notifyItemId]: isRead,
        },
      };
    }
    case 'SET_NEW_NOTIFY_ITEMS': {
      //Takes the returned payload for fetching notifyItems and
      //only adds new items. Sets the "Read"/ viewed status to false
      const data: GetHelpMenuDisplayItemsQuery = payload;
      const helpMenuNotifyItems = data.helpMenuDisplayItems;

      // state.notifyItemReadStatusMap is not spread on this object on purpose.
      // useGetHelpMenuDisplayItemsQuery returns all the relevant notifyItems (max: 10)
      const notifyItemReadStatusMap = {
        ...helpMenuNotifyItems.reduce<{ [id: number]: boolean }>((agr, notifyItem) => {
          if (!Object.hasOwn(state.notifyItemReadStatusMap, notifyItem.id)) {
            return {
              ...agr,
              [notifyItem.id]: false,
            };
          }

          return { ...agr, [notifyItem.id]: state.notifyItemReadStatusMap[notifyItem.id] };
        }, {}),
      };

      return { ...state, notifyItemReadStatusMap: notifyItemReadStatusMap };
    }
    default:
      return state;
  }
}
